var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.buttonColor,"small":"","dark":""},on:{"click":_vm.toggleStatus}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }